// Shell navigation data + inline icons, ported verbatim from the Next app's
// src/app/[locale]/layout.tsx (CE-14 P3 shell port). Kept as its own module so
// LocaleLayout stays focused on structure. The hrefs mix marketing paths
// (Next-served) and app paths (SPA) — the @/i18n/navigation Link routes each
// correctly (see isAppPath there).

/* ── Icon helpers (inline SVG, consistent with project style) ── */
export function SearchIcon() {
  return (
    <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
    </svg>
  );
}
function CodeIcon() {
  return (
    <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M17.25 6.75L22.5 12l-5.25 5.25m-10.5 0L1.5 12l5.25-5.25m7.5-3l-4.5 16.5" />
    </svg>
  );
}
function ShieldIcon() {
  return (
    <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z" />
    </svg>
  );
}
function BellIcon() {
  return (
    <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0" />
    </svg>
  );
}
function PlugIcon() {
  return (
    <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M13.19 8.688a4.5 4.5 0 011.242 7.244l-4.5 4.5a4.5 4.5 0 01-6.364-6.364l1.757-1.757m9.86-2.135a4.5 4.5 0 00-6.364-6.364L4.5 8.25l4.5 4.5" />
    </svg>
  );
}
function StoreIcon() {
  return (
    <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 21v-7.5a.75.75 0 01.75-.75h3a.75.75 0 01.75.75V21m-4.5 0H2.36m11.14 0H18m0 0h3.64m-1.39 0V9.349m-16.5 11.65V9.35m0 0a3.001 3.001 0 003.75-.615A2.993 2.993 0 009.75 9.75c.896 0 1.7-.393 2.25-1.016a2.993 2.993 0 002.25 1.016c.896 0 1.7-.393 2.25-1.016a3.001 3.001 0 003.75.614m-16.5 0a3.004 3.004 0 01-.621-4.72L4.318 3.44A1.5 1.5 0 015.378 3h13.243a1.5 1.5 0 011.06.44l1.19 1.189a3 3 0 01-.621 4.72" />
    </svg>
  );
}
function BookIcon() {
  return (
    <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 6.042A8.967 8.967 0 006 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 016 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 016-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0018 18a8.967 8.967 0 00-6 2.292m0-14.25v14.25" />
    </svg>
  );
}
function PuzzleIcon() {
  return (
    <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M14.25 6.087c0-.355.186-.676.401-.959.221-.29.349-.634.349-1.003 0-1.036-1.007-1.875-2.25-1.875s-2.25.84-2.25 1.875c0 .369.128.713.349 1.003.215.283.401.604.401.959v0a.64.64 0 01-.657.643 48.39 48.39 0 01-4.163-.3c.186 1.613.293 3.25.315 4.907a.656.656 0 01-.658.663v0c-.355 0-.676-.186-.959-.401a1.647 1.647 0 00-1.003-.349c-1.036 0-1.875 1.007-1.875 2.25s.84 2.25 1.875 2.25c.369 0 .713-.128 1.003-.349.283-.215.604-.401.959-.401v0c.31 0 .555.26.532.57a48.039 48.039 0 01-.642 5.056c1.518.19 3.058.309 4.616.354a.64.64 0 00.657-.643v0c0-.355-.186-.676-.401-.959a1.647 1.647 0 01-.349-1.003c0-1.035 1.008-1.875 2.25-1.875 1.243 0 2.25.84 2.25 1.875 0 .369-.128.713-.349 1.003-.215.283-.4.604-.4.959v0c0 .333.277.599.61.58a48.1 48.1 0 005.427-.63 48.05 48.05 0 00.582-4.717.532.532 0 00-.533-.57v0c-.355 0-.676.186-.959.401-.29.221-.634.349-1.003.349-1.035 0-1.875-1.007-1.875-2.25s.84-2.25 1.875-2.25c.37 0 .713.128 1.003.349.283.215.604.401.959.401v0a.656.656 0 00.658-.663 48.422 48.422 0 00-.37-5.36c-1.886.342-3.81.574-5.766.689a.578.578 0 01-.61-.58v0z" />
    </svg>
  );
}
function LifebuoyIcon() {
  return (
    <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M16.712 4.33a9.027 9.027 0 011.652 1.306c.51.51.944 1.064 1.306 1.652M16.712 4.33l-3.448 4.138m3.448-4.138a9.014 9.014 0 00-9.424 0M19.67 7.288l-4.138 3.448m4.138-3.448a9.014 9.014 0 010 9.424m-4.138-5.976a3.736 3.736 0 00-.88-1.388 3.737 3.737 0 00-1.388-.88m2.268 2.268a3.765 3.765 0 010 2.528m-2.268-4.796l-3.448 4.138m0 0a3.736 3.736 0 00-.88 1.388 3.735 3.735 0 000 2.528m.88-3.916l-4.138 3.448m0 0a9.027 9.027 0 01-1.306-1.652m1.306 1.652l4.138-3.448M4.33 16.712a9.014 9.014 0 010-9.424m4.138 5.976a3.765 3.765 0 010-2.528m0 0c.181-.506.483-.96.88-1.388m-.88 1.388l-4.138-3.448m4.138 3.448A3.736 3.736 0 019.4 9.512m-.88 1.388L4.33 7.288m0 0A9.027 9.027 0 015.636 5.636m-1.306 1.652l4.138 3.448m-4.138-3.448a9.014 9.014 0 019.424 0m-5.976 4.138l3.448-4.138" />
    </svg>
  );
}
function FileTextIcon() {
  return (
    <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
    </svg>
  );
}
function UserIcon() {
  return (
    <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
    </svg>
  );
}
function ArrowPathIcon() {
  return (
    <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M7.5 21L3 16.5m0 0L7.5 12M3 16.5h13.5m0-13.5L21 7.5m0 0L16.5 12M21 7.5H7.5" />
    </svg>
  );
}
function DocumentMagnifyIcon() {
  return (
    <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m5.231 13.481L15 17.25m-4.5-15H5.625c-.621 0-1.125.504-1.125 1.125v16.5c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9zm3.75 11.625a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z" />
    </svg>
  );
}
function ExclamationTriangleIcon() {
  return (
    <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
    </svg>
  );
}

/* ── Nav data — mirrors the Next chrome (src/app/[locale]/layout.tsx, CE-57).
      Labels are the EN values of the chrome.* namespace; SPA-side DE is CE-51. ── */
export const platformItems = [
  { title: "Compliance", description: "Screening, sanctions & audit trail", href: "/products/compliance", icon: <ShieldIcon /> },
  { title: "Monitoring", description: "Continuous surveillance with alerts", href: "/products/monitoring", icon: <BellIcon /> },
  { title: "Travel Rule", description: "IVMS101 records, sent over TRP", href: "/products/travel-rule", icon: <FileTextIcon /> },
  { title: "Screening API", description: "Screening and risk over REST", href: "/products/api", icon: <CodeIcon /> },
  { title: "Explorer", description: "Address risk and Bitcoin fund flows", href: "/explore", icon: <SearchIcon /> },
  { title: "SDK", description: "Pre-transaction controls for applications", href: "/products/sdk", icon: <PlugIcon /> },
  { title: "Merchant", description: "Payment acceptance with screening", href: "/merchant", icon: <StoreIcon /> },
];

export const institutionItems = [
  { title: "Compliance teams", description: "Case handling, reports, audit trails", href: "/for/compliance", icon: <FileTextIcon /> },
  { title: "Payments", description: "Screening before settlement", href: "/for/defi", icon: <ArrowPathIcon /> },
  { title: "Trading venues", description: "Onboarding and withdrawal controls", href: "/for/exchanges", icon: <StoreIcon /> },
  { title: "Public sector", description: "Evidence-grade analysis and filings", href: "/for/law-enforcement", icon: <ShieldIcon /> },
];

export const developersItems = [
  { title: "API documentation", description: "REST reference", href: "/api-docs", icon: <CodeIcon /> },
  { title: "SDK docs", description: "JavaScript SDK", href: "/sdk", icon: <PlugIcon /> },
  { title: "Free plan", description: "Evaluate on the production API", href: "/portal/signup", icon: <DocumentMagnifyIcon /> },
  { title: "Browser extension", description: "Screening in the browser", href: "/products/sdk#extension", icon: <PuzzleIcon /> },
];

/* Kept for footer/secondary surfaces (not in the header). */
export const toolsItems = [
  { title: "Wallet Profiler", description: "Classify addresses as exchange, cold wallet, or mixer", href: "/tools/wallet-profiler", icon: <UserIcon /> },
  { title: "Path Finder", description: "Find connections between two addresses", href: "/tools/path-finder", icon: <ArrowPathIcon /> },
  { title: "Transaction Decoder", description: "Plain English transaction analysis", href: "/tools/tx-decoder", icon: <DocumentMagnifyIcon /> },
  { title: "Scam Detector", description: "Detect scam patterns in wallet behavior", href: "/tools/scam-detector", icon: <ExclamationTriangleIcon /> },
];

export const resourcesItems = [
  { title: "Investigations", description: "Preliminary investigation & one-time evidence reports for individuals", href: "/investigate", icon: <SearchIcon /> },
  { title: "Guides", description: "Fraud & compliance guides", href: "/guides", icon: <BookIcon /> },
  { title: "Support", description: "FAQ & resources", href: "/support-resources", icon: <LifebuoyIcon /> },
  { title: "Contact", description: "Reach the ChainEvidence team", href: "/support", icon: <LifebuoyIcon /> },
];

export const mobileMenuGroups = [
  {
    label: "Platform",
    items: [
      { title: "Compliance", href: "/products/compliance" },
      { title: "Monitoring", href: "/products/monitoring" },
      { title: "Travel Rule", href: "/products/travel-rule" },
      { title: "Screening API", href: "/products/api" },
      { title: "Explorer", href: "/explore" },
      { title: "SDK", href: "/products/sdk" },
      { title: "Merchant", href: "/merchant" },
    ],
  },
  {
    label: "Institutions",
    items: [
      { title: "Compliance teams", href: "/for/compliance" },
      { title: "Payments", href: "/for/defi" },
      { title: "Trading venues", href: "/for/exchanges" },
      { title: "Public sector", href: "/for/law-enforcement" },
    ],
  },
  {
    label: "Developers",
    items: [
      { title: "API documentation", href: "/api-docs" },
      { title: "SDK docs", href: "/sdk" },
      { title: "Free plan", href: "/portal/signup" },
      { title: "Browser extension", href: "/products/sdk#extension" },
    ],
  },
  {
    label: "More",
    items: [
      { title: "Pricing", href: "/pricing" },
      { title: "Trust & Security", href: "/trust" },
      { title: "Investigations", href: "/investigate" },
      { title: "Guides", href: "/guides" },
      { title: "Contact", href: "/support" },
    ],
  },
];
